import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld.vue'
import UserRecordDetail from '@/components/views/admin/UserRecordDetail.vue'
import UserTransDetail from '@/components/views/admin/UserTransDetail.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            hidden: true,
            redirect: '/login'
        },
        {
            path: '/login',
            hidden: true,
            component: () => import('@/components/LoginForm')
        },
        {
            path: '/main',
            name: '订单管理',
            redirect: '/main/todayorder/',
            iconClass: 'el-icon-s-order',
            component: () => import('@/components/views/admin/MainView'),
            children: [
                {
                    path: '/main/todayorder/',
                    name: '今日订单',
                    iconClass: 'el-icon-document',
                    component: () => import('@/components/views/admin/TodayOrderView.vue')
                },
                {
                    path: '/main/order/',
                    name: '历史订单',
                    iconClass: 'el-icon-document',
                    component: () => import('@/components/views/admin/OrderView.vue')
                },
                // {
                //     path: '/main/history',
                //     name: '历史订单',
                //     iconClass: 'fa fa-list',
                //     component: () => import('@/components/views/admin/OrderView.vue')
                // }
            ]
        },
        {
            path: '/main',
            name: '服务管理',
            iconClass: 'el-icon-s-ticket',
            component: () => import('@/components/views/admin/MainView.vue'),
            children: [
                {
                    path: '/main/service/',
                    name: '服务',
                    iconClass: 'el-icon-s-ticket',
                    component: () => import('@/components/views/admin/ServiceView.vue')
                }
            ]
        },
        {
            path: '/main',
            name: '促销管理',
            iconClass: 'el-icon-s-shop',
            component: () => import('@/components/views/admin/MainView'),
            children: [
                {
                    path: '/main/parking',
                    name: '活动方案',
                    iconClass: 'el-icon-s-shop',
                    component: () => import('@/components/views/admin/PromotionView.vue')
                }
            ]
        },
        {
            path: '/main',
            name: '消息管理',
            iconClass: 'el-icon-message-solid',
            component: () => import('@/components/views/admin/MainView'),
            redirect: '/main/notice',
            children: [
                {
                    path: '/main/notice',
                    name: '消息内容',
                    iconClass: 'el-icon-message-solid',
                    component: () => import('@/components/views/admin/NoticeView.vue')
                }
            ]
        },
        {
            path: '/main',
            name: '广告管理',
            iconClass: 'el-icon-picture',
            component: () => import('@/components/views/admin/MainView'),
            redirect: '/main/ad',
            children: [
                {
                    path: '/main/ad',
                    name: '图片广告',
                    iconClass: 'el-icon-picture',
                    component: () => import('@/components/views/admin/AdView.vue')
                }
            ]
        },
        {
            path: '/main',
            name: '积分管理',
            iconClass: 'el-icon-star-off',
            component: () => import('@/components/views/admin/MainView'),
            redirect: '/main/credits',
            children: [
                {
                    path: '/main/credits',
                    name: '用户积分',
                    iconClass: 'el-icon-picture',
                    component: () => import('@/components/views/admin/CreditsView.vue')
                },
                {
                    path: '/main/redeem',
                    name: '兑换方案',
                    iconClass: 'el-icon-picture',
                    component: () => import('@/components/views/admin/RedeemView.vue')
                },
                // {
                //     path: '/main/credits/:id',
                //     name: '水滴详情',
                //     iconClass: 'el-icon-picture',
                //     component: () => import('@/components/views/admin/AdView.vue')
                // },
            ]
        },
        {
            path: '/main',
            name: '用户管理',
            iconClass: 'fa fa-user',
            component: () => import('@/components/views/admin/MainView'),
            children: [
                {
                    path: '/main/user',
                    name: '用户',
                    iconClass: 'fa fa-user',
                    component: () => import('@/components/views/admin/UserView.vue')
                },
                {
                    path: '/main/admin',
                    name: '管理员',
                    iconClass: 'fa fa-user',
                    component: () => import('@/components/views/admin/AdminUserView.vue')
                }
            ]
        },
        {
            path: '/main',
            name: '用户详情',
            hidden: true,
            iconClass: 'fa fa-user',
            component: () => import('@/components/views/admin/MainView.vue'),
            children: [
                {
                    path: '/main/userdetail/:id',
                    name: '用户订单详情',
                    iconClass: 'fa fa-user',
                    component: UserRecordDetail, //() => import('@/components/views/admin/UserRecordDetail.vue'),
                    // key: route => route.fullPath
                },
                {
                    path: '/main/transdetail/:id',
                    name: '用户交易详情',
                    iconClass: 'fa fa-user',
                    component: UserTransDetail, //() => import('@/components/views/admin/UserTransDetail.vue'),
                    // key: route => route.fullPath
                },
                {
                    path: '/main/creditsdetail/:id',
                    name: '用户积分详情',
                    iconClass: 'fa fa-user',
                    component: () => import('@/components/views/admin/CreditsDetail.vue'),
                    // key: route => route.fullPath
                }
            ]

        },
        {
            path: '/main',
            name: '系统配置',
            iconClass: 'fa fa-user',
            component: () => import('@/components/views/admin/MainView.vue'),
            children: [
                {
                    path: '/main/wxconfig',
                    name: '微信配置',
                    iconClass: 'fa fa-user',
                    component: () => import('@/components/views/admin/SystemConfig.vue'),
                    // key: route => route.fullPath
                },
                {
                    path: '/main/thzconfig',
                    name: '服务时段',
                    iconClass: 'fa fa-user',
                    component: () => import('@/components/views/admin/ThzServicePeroidsView.vue'),
                    // key: route => route.fullPath
                },
            ]

        },
        {
            path: '*',
            hidden: true,
            component: () => import('@/components/NotFound')
        }
    ],
    mode: 'history'

})
